import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import { ADD_END_WALL_STAGE_ONE, ADD_END_WALL_STAGE_TWO, GET_END_WALL_STAGE_ONE, GET_END_WALL_STAGE_TWO, GET_EW_STAGE_ONE_DATA, LIST_END_WALL_STAGE_TWO,UPDATE_EW_FLOW_STATUS,GET_EW_FRAME_NUMBER,GET_EW_DRAWING_NUMBER,GET_VIEW_EW_STAGE_ONE_DATA ,GET_VIEW_EW_STAGE_TWO_DATA, DATA_GET_END_WALLFLOW_HISTORY, UPDATE_ALL_ONE_ACTION,FETCH_MASTER_EW_NUMBERS ,DELETE_END_WALL_DATA} from '../../../api/apiConstant';


export const fetchEndWallStageOneForm = createAsyncThunk(
  'endWall/fetchEndWallStageOneForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_END_WALL_STAGE_ONE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchEndWallStageTwoForm = createAsyncThunk(
  'endWall/fetchEndWallStageTwoForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_END_WALL_STAGE_TWO, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchEndWallStageOneData = createAsyncThunk(
  'endWall/fetchEndWallStageOneData',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_EW_STAGE_ONE_DATA, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const addEndWallStageOneData = createAsyncThunk(
  'endWall/addEndWallStageOneData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_END_WALL_STAGE_ONE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const addEndWallStageTwoData = createAsyncThunk(
  'endWall/addEndWallStageTwoData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_END_WALL_STAGE_TWO, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const fetchEndWallStageTwoData = createAsyncThunk(
  'endWall/fetchEndWallStageTwoData',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_END_WALL_STAGE_TWO, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch materials'
      );
    }
  }
);

export const UpdateEwFlowStatus = createAsyncThunk(
  'material/UpdateEwFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_EW_FLOW_STATUS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add under frame stage one data',
      );
    }
  },
);

export const fetchEwFrameNumber = createAsyncThunk(
  'endWall/fetchEwFrameNumber',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_EW_FRAME_NUMBER,{ params } );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch frame numbers',
      );
    }
  },
);

export const fetchEwDrawingNumber = createAsyncThunk(
  'endWall/fetchEwDrawingNumber',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_EW_DRAWING_NUMBER);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch frame numbers',
      );
    }
  },
);

export const fetchViewEwStageOneData = createAsyncThunk(
  'endWall/fetchViewEwStageOneData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_EW_STAGE_ONE_DATA, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
); 

export const fetchViewEwStageTwoData = createAsyncThunk(
  'endWall/fetchViewEwStageTwoData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_EW_STAGE_TWO_DATA, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
); 

export const fetchEndWallFlowHistory = createAsyncThunk(
  'endWall/fetchEndWallFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(DATA_GET_END_WALLFLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch history');
    }
  },
);

export const fetchNewEndWallFlowHistory = createAsyncThunk(
  'endWall/fetchNewEndWallFlowHistory',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        DATA_GET_END_WALLFLOW_HISTORY,
        payload
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch history'
      );
    }
  },
);

export const endWallActionStageOne = createAsyncThunk(
  'sideWall/endWallActionStageOne',
  async (action, { rejectWithValue }) => {
    try {
      const response = await api.post(`${UPDATE_ALL_ONE_ACTION}`, { ...action });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Action failed');
    }
  },
);

export const fetchEwMasterNumbers = createAsyncThunk(
  'endWall/fetchEwMasterNumbers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_EW_NUMBERS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch Under frame numbers',
      );
    }
  },
);

export const deleteEndWallData = createAsyncThunk(
  'furnishing/deleteEndWallData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_END_WALL_DATA, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);